/* eslint-disable import/prefer-default-export */
export async function locationSearch(view, geocoder, geocodeUrl, Circle, Graphic, radiusMeters = 10000) {
  const parent = document.getElementById('js-project-search-from');
  const input = parent.querySelector('#js-project-search-input');
  const acton = parent.querySelector('#js-project-search-button');

  parent.addEventListener('submit', (event) => {
    event.preventDefault();
  });

  input.addEventListener('input', () => {
    const value = input.value.trim();

    if (!value) {
      view.graphics.removeAll();
    }
  });

  acton.addEventListener('click', async () => {
    const searchText = input.value.trim();
    if (!searchText) {
      return;
    }

    try {
      const results = await geocoder.addressToLocations(geocodeUrl, {
        address: { SingleLine: `${searchText} Deutschland` },
        countryCode: 'DE',
        maxLocations: 1,
      });

      if (!results.length) {
        console.warn('Ort nicht gefunden.');
        return;
      }

      const location = results[0].location;
      const circle = new Circle({
        center: location,
        radius: radiusMeters,
        radiusUnit: 'meters',
        geodesic: true,
      });

      view.graphics.removeAll();
      view.graphics.add(new Graphic({
        geometry: circle,
        symbol: {
          type: 'simple-fill',
          width: radiusMeters,
          height: radiusMeters,
          color: [62, 0, 49, 0.1],
          outline: {
            color: [30, 0, 25, 0.5],
            width: 3,
          },
        },
      }));

      view.goTo(circle.extent.expand(1.2));
    } catch (error) {
      console.warn('Fehler bei Ortssuche:', error);
    }
  });
}
